// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ServerApproveRolloutRequest
 */
export interface ServerApproveRolloutRequest {
  /**
   *
   * @type {number}
   * @memberof ServerApproveRolloutRequest
   */
  step?: number;
}

/**
 * Check if a given object implements the ServerApproveRolloutRequest interface.
 */
export function instanceOfServerApproveRolloutRequest(
  value: object,
): value is ServerApproveRolloutRequest {
  return true;
}

export function ServerApproveRolloutRequestFromJSON(
  json: any,
): ServerApproveRolloutRequest {
  return ServerApproveRolloutRequestFromJSONTyped(json, false);
}

export function ServerApproveRolloutRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ServerApproveRolloutRequest {
  if (json == null) {
    return json;
  }
  return {
    step: json['step'] == null ? undefined : json['step'],
  };
}

export function ServerApproveRolloutRequestToJSON(
  json: any,
): ServerApproveRolloutRequest {
  return ServerApproveRolloutRequestToJSONTyped(json, false);
}

export function ServerApproveRolloutRequestToJSONTyped(
  value?: ServerApproveRolloutRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    step: value['step'],
  };
}
